import { partnerClient } from '@modules/core/services';

import { UseQueryReferralsParams, ReferralsResponse, ReferralsQueryParams } from '../types';

export const fetchReferrals = async <T>({ ...queryParams }: UseQueryReferralsParams): Promise<ReferralsResponse<T>> => {
  const params: ReferralsQueryParams = {
    from: queryParams.from,
    to: queryParams.to,
    status: queryParams.status,
    q: queryParams.q,
  };

  const sort = queryParams?.sort;
  if (sort && !!Object.keys(sort)?.[0]) {
    params.sortField = Object.keys(sort)?.[0];
    params.sortOrder = Object.values(sort)?.[0] ? 'asc' : 'desc';
  }

  return await partnerClient.get('appointments', {
    params,
  });
};
